import { render, staticRenderFns } from "./teacher-login-form.vue?vue&type=template&id=45e9efd4&lang=pug&"
import script from "./teacher-login-form.vue?vue&type=script&lang=js&"
export * from "./teacher-login-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports